import React, { useState, useEffect } from "react";
import {Modal} from "antd";
import { Row, Col } from 'antd';
import _ from 'i18n';

const DeleteCardConfirmation = ({ id, visible, hideModal, deleteCard }) => {
    return (
      <Modal
        width="632px"
        title={null}
        visible={visible}
        wrapClassName={'delete-card-pop-up'}
        footer={null}
        closable={false}
      >
          <div className={'delete-card-message pr-10 pl-10 flex justify-center'}>{_('CONFIRM_DELETE_CARD')}</div>
          <Row className={'p-8'}>
            <Col span={12}>
              <button className="card-cancel-button p-3 flex items-center"  onClick={hideModal}>{_('cancel')}</button>
            </Col>
            <Col span={12} className={'flex justify-end'}>
              <button className="card-delete-button p-3 flex items-center" onClick={() => deleteCard(id)}>{_('YES_DELETE')}</button>
            </Col>
          </Row>
      </Modal>
    );
}




// WEBPACK FOOTER //
// ./app/components/paymentModes/DeleteCardConfirmation.js